//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: 'Ù¡',
            2: 'Ù¢',
            3: 'Ù£',
            4: 'Ù¤',
            5: 'Ù¥',
            6: 'Ù¦',
            7: 'Ù§',
            8: 'Ù¨',
            9: 'Ù©',
            0: 'Ù ',
        },
        numberMap = {
            'Ù¡': '1',
            'Ù¢': '2',
            'Ù£': '3',
            'Ù¤': '4',
            'Ù¥': '5',
            'Ù¦': '6',
            'Ù§': '7',
            'Ù¨': '8',
            'Ù©': '9',
            'Ù ': '0',
        },
        months = [
            'Ú©Ø§ÙÙÙÛ Ø¯ÙÙÛÙ',
            'Ø´ÙØ¨Ø§Øª',
            'Ø¦Ø§Ø²Ø§Ø±',
            'ÙÛØ³Ø§Ù',
            'Ø¦Ø§ÛØ§Ø±',
            'Ø­ÙØ²ÛÛØ±Ø§Ù',
            'ØªÛÙÙÙØ²',
            'Ø¦Ø§Ø¨',
            'Ø¦ÛÛÙÙÙÙ',
            'ØªØ´Ø±ÛÙÛ ÛÛÙÛÙ',
            'ØªØ´Ø±ÛÙÛ Ø¯ÙÙÛÙ',
            'ÙØ§ÙÙÙÛ ÛÛÚ©ÛÙ',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'ÛÙâÙØ´ÙâÙÙÙâ_Ø¯ÙÙØ´ÙâÙÙÙâ_Ø³ÛØ´ÙâÙÙÙâ_ÚÙØ§Ø±Ø´ÙâÙÙÙâ_Ù¾ÛÙØ¬Ø´ÙâÙÙÙâ_ÙÙâÛÙÛ_Ø´ÙâÙÙÙâ'.split(
                '_'
            ),
        weekdaysShort:
            'ÛÙâÙØ´ÙâÙ_Ø¯ÙÙØ´ÙâÙ_Ø³ÛØ´ÙâÙ_ÚÙØ§Ø±Ø´ÙâÙ_Ù¾ÛÙØ¬Ø´ÙâÙ_ÙÙâÛÙÛ_Ø´ÙâÙÙÙâ'.split('_'),
        weekdaysMin: 'Û_Ø¯_Ø³_Ú_Ù¾_Ù_Ø´'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /Ø¦ÛÙØ§Ø±Ùâ|Ø¨ÙâÛØ§ÙÛ/,
        isPM: function (input) {
            return /Ø¦ÛÙØ§Ø±Ùâ/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'Ø¨ÙâÛØ§ÙÛ';
            } else {
                return 'Ø¦ÛÙØ§Ø±Ùâ';
            }
        },
        calendar: {
            sameDay: '[Ø¦ÙâÙØ±Û ÙØ§ØªÚÙÛØ±] LT',
            nextDay: '[Ø¨ÙâÛØ§ÙÛ ÙØ§ØªÚÙÛØ±] LT',
            nextWeek: 'dddd [ÙØ§ØªÚÙÛØ±] LT',
            lastDay: '[Ø¯ÙÛÙÛ ÙØ§ØªÚÙÛØ±] LT',
            lastWeek: 'dddd [ÙØ§ØªÚÙÛØ±] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ÙÙâ %s',
            past: '%s',
            s: 'ÚÙâÙØ¯ ÚØ±ÙÙâÛÙâÙ',
            ss: 'ÚØ±ÙÙâ %d',
            m: 'ÛÙâÙ Ø®ÙÙÙâÙ',
            mm: '%d Ø®ÙÙÙâÙ',
            h: 'ÛÙâÙ ÙØ§ØªÚÙÛØ±',
            hh: '%d ÙØ§ØªÚÙÛØ±',
            d: 'ÛÙâÙ ÚÛÚ',
            dd: '%d ÚÛÚ',
            M: 'ÛÙâÙ ÙØ§ÙÚ¯',
            MM: '%d ÙØ§ÙÚ¯',
            y: 'ÛÙâÙ Ø³Ø§Úµ',
            yy: '%d Ø³Ø§Úµ',
        },
        preparse: function (string) {
            return string
                .replace(/[Ù¡Ù¢Ù£Ù¤Ù¥Ù¦Ù§Ù¨Ù©Ù ]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/Ø/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, 'Ø');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));
